export default __webpack_public_path__ + "static/media/Team-Q.8e0c5d62.jpg";